"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheManager = void 0;
var shaka_player_1 = require("shaka-player");
var indexedDBDriver_1 = require("./indexedDBDriver");
var storageManager_1 = require("../storageManager");
var utils_1 = require("../utils");
var values_1 = __importDefault(require("lodash/values")); // Object.values is not transpiled into es5
var debug_1 = __importDefault(require("debug"));
var log = debug_1.default('persie:cm');
var dbName = 'sc-video';
var objectStores = {
    manifests: 'manifests',
    segments: 'segments'
};
var indexedDbVersion = 3;
// eslint-disable-next-line @typescript-eslint/no-empty-function
var noopAbortFunc = function () { };
var defaultConf = {
    cacheType: 'indexedDB',
    cacheRetentionLimit: 30 * 24,
    cacheLimits: {
        minThresholdPercentage: 10
    }
};
var MIN_ALLOWED_CACHE_QUOTA = utils_1.MBToBytes(50);
var CacheManager = /** @class */ (function () {
    function CacheManager(_opts) {
        if (_opts === void 0) { _opts = {}; }
        this.cacheDriver = new indexedDBDriver_1.IndexedDBDriver(dbName, values_1.default(objectStores), indexedDbVersion);
        this.ongoingOperations = new Map();
        this.storageManager = new storageManager_1.StorageManager();
        this.cacheHealthy = false;
        this.storedManifests = new Map();
        this.opts = Object.assign({}, defaultConf, _opts);
        var minThresholdPercentage = this.opts.cacheLimits.minThresholdPercentage;
        // sanity checks
        if (minThresholdPercentage < 0 || minThresholdPercentage >= 100) {
            this.opts.cacheLimits.minThresholdPercentage = 10;
        }
        this.handleNetworkRequest = this.handleNetworkRequest.bind(this);
        this.cacheClearOperation = new utils_1.PeriodicOperation(this.removeStaleManifests.bind(this), utils_1.hoursInMs(1));
    }
    CacheManager.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageSummary, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.cacheDriver.init()];
                    case 1:
                        _b.sent();
                        if (this.opts.cacheType !== 'none') {
                            log('Registering schemes');
                            // Do not listen to http requests if no caching is needed
                            shaka_player_1.net.NetworkingEngine.registerScheme('http', this.handleNetworkRequest);
                            shaka_player_1.net.NetworkingEngine.registerScheme('https', this.handleNetworkRequest);
                        }
                        this.cacheClearOperation.start();
                        return [4 /*yield*/, this.storageManager.storageSummary()];
                    case 2:
                        storageSummary = _b.sent();
                        log('Storage summary', storageSummary);
                        _a = this;
                        return [4 /*yield*/, this.ensureCacheIsHealthy()];
                    case 3:
                        _a.cacheHealthy = _b.sent();
                        return [4 /*yield*/, this.syncManifests()];
                    case 4:
                        _b.sent();
                        log('Existing manifests', Array.from(this.storedManifests.values()));
                        return [2 /*return*/];
                }
            });
        });
    };
    CacheManager.prototype.syncManifests = function () {
        return __awaiter(this, void 0, void 0, function () {
            var existingManifests;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cacheDriver.getAllItems(objectStores.manifests)];
                    case 1:
                        existingManifests = _a.sent();
                        this.storedManifests = new Map(existingManifests.map(function (m) { return [m.key, { key: m.key, lastAccessed: m.lastAccessed }]; }));
                        return [2 /*return*/];
                }
            });
        });
    };
    CacheManager.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.cacheClearOperation.stop();
                this.cacheDriver.destroy();
                return [2 /*return*/];
            });
        });
    };
    CacheManager.prototype.handleManifestTouched = function (manifestData) {
        var key = manifestData.key, lastAccessed = manifestData.lastAccessed;
        this.storedManifests.set(key, { key: key, lastAccessed: lastAccessed });
    };
    CacheManager.prototype.isCachable = function (request, videoPlayer) {
        // decide if we should attempt to cache or not
        var shallCache = videoPlayer.getConfiguration().shallCache;
        if (!shallCache) {
            return false;
        }
        var isLive = request._videoPlayer.isLive();
        if (request.method === 'GET' && !isLive) {
            return true;
        }
        log('Not cachable', { uris: request.uris.join(','), method: request.method, live: isLive });
        return false;
    };
    CacheManager.prototype.ensureCacheIsHealthy = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storage, quota;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storageManager.storage()];
                    case 1:
                        storage = _a.sent();
                        if (!storage) {
                            log('Caching is not suitable on this device, no navigator.storage');
                            return [2 /*return*/, false];
                        }
                        quota = storage.quota;
                        if (quota >= MIN_ALLOWED_CACHE_QUOTA) {
                            // if quota is very small not worth to try caching
                            return [2 /*return*/, true];
                        }
                        log("Caching is not suitable on this device, too little quota " + quota);
                        return [2 /*return*/, false];
                }
            });
        });
    };
    CacheManager.prototype.claimMemory = function (byteSize) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cacheDriver.freeMemory(byteSize, objectStores.segments)];
            });
        });
    };
    CacheManager.prototype.storeSegment = function (key, data, metadata) {
        return __awaiter(this, void 0, void 0, function () {
            var storage, minThresholdPercentage, quota, usage, blobSize, allowedQuota, remaining, memoryToClaim, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.storageManager.storage()];
                    case 1:
                        storage = _a.sent();
                        if (!storage)
                            return [2 /*return*/];
                        if (!this.storedManifests.has(metadata.manifest)) {
                            log('No matching manifest index, not caching', metadata.manifest, key);
                            return [2 /*return*/];
                        }
                        minThresholdPercentage = this.opts.cacheLimits.minThresholdPercentage;
                        quota = storage.quota, usage = storage.usage;
                        blobSize = data.byteLength;
                        allowedQuota = quota - quota * (minThresholdPercentage / 100);
                        remaining = Math.max(0, allowedQuota - usage);
                        if (!(blobSize > remaining)) return [3 /*break*/, 3];
                        log('Claim memory', { blobSize: blobSize, remaining: remaining, allowedQuota: allowedQuota });
                        memoryToClaim = blobSize - remaining;
                        return [4 /*yield*/, this.claimMemory(memoryToClaim)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, this.cacheDriver.storeItem(key, data, metadata, objectStores.segments)];
                    case 4:
                        err_1 = _a.sent();
                        log("storeSegment for " + key + " failed:", err_1);
                        return [2 /*return*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CacheManager.prototype.getAsset = function (type, assetKey) {
        return __awaiter(this, void 0, void 0, function () {
            var itemKey, getItemPromise, asset, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        itemKey = type === 'manifest' ? assetKey[0] : assetKey;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        getItemPromise = type === 'manifest' ? this.cacheDriver.getItem(itemKey, objectStores.manifests) : this.cacheDriver.getItem(itemKey, objectStores.segments);
                        return [4 /*yield*/, getItemPromise];
                    case 2:
                        asset = _a.sent();
                        return [2 /*return*/, asset];
                    case 3:
                        err_2 = _a.sent();
                        log("getAsset for " + itemKey + " failed:", err_2);
                        return [2 /*return*/, undefined];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CacheManager.prototype.storeAsset = function (type, assetKey, mainManifestUri, response) {
        return __awaiter(this, void 0, void 0, function () {
            var startTs, itemKey, data, responseMetadata, manifest, assetMetadata, segment, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startTs = Date.now();
                        log('storeAsset', type, response);
                        itemKey = type === 'manifest' ? assetKey[0] : assetKey;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        data = response.data, responseMetadata = __rest(response, ["data"]);
                        if (!(type === 'manifest')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.cacheDriver.storeItem(itemKey, data, responseMetadata, objectStores.manifests)];
                    case 2:
                        manifest = _a.sent();
                        this.handleManifestTouched(manifest);
                        return [2 /*return*/, manifest];
                    case 3:
                        assetMetadata = __assign(__assign({}, responseMetadata), { manifest: mainManifestUri });
                        return [4 /*yield*/, this.storeSegment(assetKey, data, assetMetadata)];
                    case 4:
                        segment = _a.sent();
                        log("storeAsset segment took " + utils_1.timeDelta(startTs) + "s", assetKey);
                        return [2 /*return*/, segment];
                    case 5:
                        err_3 = _a.sent();
                        log("storeItem for " + itemKey + " failed:", err_3);
                        return [2 /*return*/, undefined];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CacheManager.prototype.handleNetworkRequest = function (uri, request, requestType, progressUpdated) {
        var _this = this;
        log('Request:', request, requestType, uri);
        // check if fetch is supported. isSupported method looks for window.fetch and window.AbortController
        var requestMethod = shaka_player_1.net.HttpFetchPlugin.isSupported() ? shaka_player_1.net.HttpFetchPlugin : shaka_player_1.net.HttpXHRPlugin;
        var makeRequest = function () { return requestMethod(uri, request, requestType, progressUpdated); };
        var videoPlayer = request._videoPlayer;
        var assetKey = [uri, request.headers.Range || ''];
        var assetKeyStr = assetKey.join(''); // Only used for tracking ongoing operations!
        var mainManifestUri = request._videoPlayer.getConfiguration().src;
        var isMainManifestRequest = uri === mainManifestUri;
        if (!this.isCachable(request, videoPlayer) || !this.cacheHealthy) {
            return makeRequest();
        }
        // shaka player expects AbortableOperation so converting our promise to an Abortable operation and if we cannot serve it from cache,
        // we are making a http request which returns AbortableOperation. 
        return new shaka_player_1.util.AbortableOperation(this.getAsset(isMainManifestRequest ? 'manifest' : 'segment', assetKey), noopAbortFunc).chain(function (asset) {
            if (asset) {
                var metadata = asset.metadata, data = asset.data;
                var response = __assign(__assign({}, metadata), { data: data, fromCache: true });
                return response;
            }
            // make sure we do not have the same request ongoing already, otherwise return it
            if (_this.ongoingOperations.has(assetKeyStr)) {
                return _this.ongoingOperations.get(assetKeyStr);
            }
            // call the default fetch plugin in shaka player
            var req = makeRequest();
            _this.ongoingOperations.set(assetKeyStr, req);
            // if the http request is successful then we need to hack into the underlying promise to cache the result. 
            req.promise.catch(function (err) {
                log('Fetching failed, asset is not gonna be cached:', err);
                throw err;
            }).then(function (response) {
                return _this.storeAsset(isMainManifestRequest ? 'manifest' : 'segment', assetKey, mainManifestUri, response);
            }).finally(function () {
                _this.ongoingOperations.delete(assetKeyStr);
            });
            return req;
        });
    };
    // TODO: move the transaction logic to indexeddb driver
    CacheManager.prototype.removeCachedVideoData = function (manifestUri) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (!_this.cacheDriver.db) {
                            return reject(new Error('DB not initialized'));
                        }
                        var transaction = _this.cacheDriver.db.transaction([objectStores.segments, objectStores.manifests], 'readwrite');
                        var assets = transaction.objectStore(objectStores.segments);
                        var res = [];
                        var request = assets.openCursor();
                        request.onsuccess = function () {
                            var cursor = request.result;
                            if (cursor) {
                                var value = cursor.value;
                                if (value.metadata.manifest === manifestUri) {
                                    res.push(value.key[0]);
                                    cursor.delete();
                                }
                                cursor.continue();
                            }
                        };
                        var manifests = transaction.objectStore(objectStores.manifests);
                        manifests.delete(manifestUri);
                        transaction.oncomplete = function () { return resolve(res); };
                        transaction.onerror = function (event) { return reject(event); };
                        transaction.onabort = function (event) { return reject(event); };
                    })];
            });
        });
    };
    CacheManager.prototype.removeManifestsBeforeDate = function (dateLimit) {
        return __awaiter(this, void 0, void 0, function () {
            var staleManifests;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        log('Checking stale manifests older than:', dateLimit);
                        return [4 /*yield*/, this.syncManifests()];
                    case 1:
                        _a.sent(); // make sure we have the latest manifests, i.e. another tab was open
                        staleManifests = Array.from(this.storedManifests.values()).filter(function (m) { return m.lastAccessed <= dateLimit; });
                        if (staleManifests.length) {
                            log('Removing manifests:', staleManifests);
                            return [2 /*return*/, Promise.all(staleManifests.map(function (m) { return _this.removeCachedVideoData(m.key); }))];
                        }
                        return [2 /*return*/, []];
                }
            });
        });
    };
    CacheManager.prototype.removeStaleManifests = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dateLimit;
            return __generator(this, function (_a) {
                dateLimit = new Date();
                dateLimit.setHours(dateLimit.getHours() - this.opts.cacheRetentionLimit);
                return [2 /*return*/, this.removeManifestsBeforeDate(dateLimit)];
            });
        });
    };
    // TODO: move the transaction logic to indexeddb driver
    CacheManager.prototype.getCachedSegmentsSize = function (segmentUris) {
        return __awaiter(this, void 0, void 0, function () {
            var getSegmentSizes, sizeList, sizeMap;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        getSegmentSizes = function () {
                            return new Promise(function (resolve, reject) {
                                if (!_this.cacheDriver.db) {
                                    return resolve([]);
                                }
                                var transaction = _this.cacheDriver.db.transaction(objectStores.segments, 'readonly');
                                var assets = transaction.objectStore(objectStores.segments);
                                var res = [];
                                var request = assets.openCursor();
                                request.onsuccess = function () {
                                    var cursor = request.result;
                                    if (cursor) {
                                        var key = cursor.primaryKey;
                                        var uri = key[0];
                                        if (uri && segmentUris.indexOf(uri) > -1) {
                                            var asset = cursor.value;
                                            var size = asset.data.byteLength;
                                            res.push({ key: key, size: size });
                                        }
                                        cursor.continue();
                                    }
                                };
                                transaction.oncomplete = function () { return resolve(res); };
                                transaction.onerror = function (event) { return reject(event); };
                                transaction.onabort = function (event) { return reject(event); };
                            });
                        };
                        return [4 /*yield*/, getSegmentSizes()];
                    case 1:
                        sizeList = _a.sent();
                        sizeMap = new Map();
                        sizeList.forEach(function (_a) {
                            var key = _a.key, chunkSize = _a.size;
                            var uri = key[0];
                            var rangeText = key[1];
                            var entry = sizeMap.get(uri);
                            var complete = !rangeText;
                            if (!entry) {
                                sizeMap.set(uri, { complete: complete, size: chunkSize });
                            }
                            else {
                                if (entry.complete)
                                    return; // we already have the full chunks size, ignore the partial content
                                var totalSize = chunkSize;
                                if (!complete) {
                                    totalSize += entry.size;
                                }
                                sizeMap.set(uri, { complete: complete, size: totalSize });
                            }
                        });
                        return [2 /*return*/, utils_1.sum(Array.from(sizeMap.values()).map(function (s) { return s.size; }))];
                }
            });
        });
    };
    CacheManager.prototype.clearDB = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cacheDriver.clearDB()];
            });
        });
    };
    CacheManager.prototype.deleteDB = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cacheDriver.deleteDB()];
            });
        });
    };
    return CacheManager;
}());
exports.CacheManager = CacheManager;
